module.exports = __webpack_public_path__ + "img/linked.5884025d.svg";